const PENDING_AGENT_KEY = "jhonks_pending_agent_id_v1";

export const preAuthIntent = {
  setPendingAgent: (agentId) => {
    if (!agentId) return;
    localStorage.setItem(PENDING_AGENT_KEY, String(agentId));
  },

  getPendingAgent: () => {
    try {
      return localStorage.getItem(PENDING_AGENT_KEY);
    } catch {
      return null;
    }
  },

  clearPendingAgent: () => {
    try {
      localStorage.removeItem(PENDING_AGENT_KEY);
    } catch {
      // ignore
    }
  },
};

